import { useQuery } from "@tanstack/react-query";
import { fetchOnlyData as fetchAdminData } from "./adminApi";
import { fetchOnlyData as fetchManagerData } from "./managerApi";
import CashierApi from "../utility/CashierApi";

function useDefaultCurrency(role) {
  // Get the methods from CashierApi
  const { fetchOnlyData: fetchCashierData } = CashierApi();

  // Function to determine the correct fetch function based on the role
  const getFetchFunction = () => {
    switch (role) {
      case "admin":
        return fetchAdminData;
      case "manager":
        return fetchManagerData;
      case "cashier":
        return fetchCashierData;
      default:
        throw new Error("Invalid role specified");
    }
  };

  // Use React Query to fetch data based on the role
  const { data, error, isLoading } = useQuery({
    queryKey: ["defaultCurrency", role], // Cache key depends on the role
    queryFn: () => getFetchFunction()("currency-settings"), // Call the correct function with endpoint
    staleTime: 1000 * 60 * 50, // Data is considered fresh for 50 minutes
    cacheTime: 1000 * 60 * 60, // Cache data for 60 minutes
    retry: 1, // Retry once on failure
    keepPreviousData: true, // Keep previous data while fetching new data
    refetchOnMount: false, // Prevent refetching on component mount
    refetchOnWindowFocus: false, // Prevent refetching when window regains focus
    refetchOnReconnect: false, // Prevent refetching when network reconnects
  });

  return { data, error };
}

export default useDefaultCurrency;
